<template>
  <AuthLayout :title="title">
    <p v-if="verifying" role="status" class="text-muted italic">
      {{ $t("loading") }}
    </p>

    <div v-else-if="errorMessage" class="flex flex-col gap-4">
      <p role="alert" class="text-red-400">{{ errorMessage }}</p>
      <p class="text-subtle text-sm leading-relaxed">
        {{ $t("auth.verify.errorHint") }}
      </p>
    </div>

    <div v-else role="status" class="flex flex-col gap-4">
      <p class="text-muted leading-relaxed">
        {{
          alreadyVerified
            ? $t("auth.verify.alreadyBody")
            : $t("auth.verify.doneBody")
        }}
      </p>
      <router-link
        to="/login"
        class="text-highlight text-sm hover:underline self-start"
      >
        {{ $t("auth.reset.signIn") }}
      </router-link>
    </div>
  </AuthLayout>
</template>

<script>
import AuthLayout from "@/components/auth/AuthLayout.vue";

export default {
  name: "VerifyAccount",
  components: { AuthLayout },

  data() {
    return {
      verifying: true,
      alreadyVerified: false,
      errorMessage: "",
    };
  },

  computed: {
    title() {
      if (this.verifying) return this.$t("auth.verify.title");
      if (this.errorMessage) return this.$t("auth.verify.errorTitle");
      return this.alreadyVerified
        ? this.$t("auth.verify.alreadyTitle")
        : this.$t("auth.verify.doneTitle");
    },
  },

  mounted() {
    const { hash, key, token } = this.$route.params;

    // Nothing to confirm here — clicking the link is the confirmation.
    this.$store
      .dispatch("verifyAccount", { hash, userId: key, token })
      .then((data) => {
        this.alreadyVerified = Boolean(data?.wasAlreadyVerified);
      })
      .catch(() => {
        this.errorMessage = this.$t("auth.error.invalidToken").toString();
      })
      .finally(() => (this.verifying = false));
  },
};
</script>
